import { FC, useMemo } from 'react'

import { getHelloSitesUrl } from 'api/utils/paths'
import { useRouterExtend } from 'hooks/useRouterExtend'
import { basePath } from 'interfaces/constants'
import { Category } from 'interfaces/types'

import { useHomeCategory } from './HomeCategory.hooks'
import { StyledCarouselTag, StyledCategoryItem } from './HomeCategory.styled'

export type HomeCategoryProps = {
  categories?: Category[]
  className?: string
}

export const HomeCategory: FC<HomeCategoryProps> = (props) => {
  const { categories = [], className } = props

  const { locale } = useRouterExtend()

  const { carouselItemsCategory } = useHomeCategory({
    categories,
    maxItems: 12,
  })

  const currentDomain = useMemo(() => getHelloSitesUrl(locale), [locale])

  return (
    <StyledCarouselTag
      dragFree
      containScroll="trimSnaps"
      className={className}
      items={carouselItemsCategory}
      itemTracking={{
        prev: {
          'data-event-category': 'Recommended Topics',
          'data-event-action': 'See More Topics',
          'data-event-label': `${currentDomain}${basePath}`,
        },
        next: {
          'data-event-category': 'Recommended Topics',
          'data-event-action': 'See More Topics',
          'data-event-label': `${currentDomain}${basePath}`,
        },
      }}
      renderItem={(item, index) => {
        return (
          <StyledCategoryItem
            key={`${index}`}
            {...item.itemProps}
            href={item.href}
          >
            <span className="hhg-icon">
              {typeof item.icon === 'string' ? (
                <img loading="lazy" src={item.icon} alt="" />
              ) : (
                item.icon
              )}
            </span>
            <span className="label">{item.title}</span>
          </StyledCategoryItem>
        )
      }}
    />
  )
}
